import { Api as SharedApi } from "shared-ui/utils/api";
import { router } from "@/router";
import { useAuthStore } from "@/stores/auth-store.ts";

export class Api extends SharedApi {
  constructor(getLocale?: () => string) {
    super({
      prefix: "/api",
      getHeaders: () =>
        Promise.resolve<Record<string, string>>(
          getLocale ? { "Accept-Language": getLocale() } : {},
        ),
      onUnauthorized: async (request) => {
        // If current route doesn't require auth, then do nothing
        if (router.currentRoute.value.meta.requiresAuth === false) {
          return;
        }

        // Allow 401 response on /auth/login (e.g. invalid credentials)
        if (request.url.endsWith("/api/auth/login")) {
          return;
        }

        // Handle session expiration, logout the user
        console.warn("Session expired. Logging out...");
        // For avoiding an infinite logout loop
        if (
          !request.url.endsWith("/auth/logout") &&
          router.currentRoute.value.path !== "/"
        ) {
          const authStore = useAuthStore();
          await authStore.logout();

          return;
        } else if (router.currentRoute.value.path !== "/") {
          await router.push("/");

          return;
        }

        throw new Error("Session expired. Please log in again.");
      },
      onDeletionScheduled: (): Promise<void> => useAuthStore().checkAuth(true),
    });
  }
}
